import { render, staticRenderFns } from "./TabContent.vue?vue&type=template&id=eef83b56&scoped=true"
import script from "./TabContent.vue?vue&type=script&lang=js"
export * from "./TabContent.vue?vue&type=script&lang=js"
import style0 from "./TabContent.vue?vue&type=style&index=0&id=eef83b56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eef83b56",
  null
  
)

export default component.exports